import {
	showcaseByID,
	showcaseCreate,
	showcaseDestroy,
	showcaseList,
	showcaseSetCurrent,
	showcaseToggleMediaPartnerApplications,
	showcaseUpdate,
} from '@/services/agency/showcases.service'

export default {
	namespaced: true,
	state: {
		// SERVICE SHOWCASE
		showcaseList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		showcase: {},

		// STATUS SERVICE SHOWCASE
		showcaseStatus: 'pending',
		showcaseSaveStatus: 'init',
		showcaseDeleteStatus: 'init',
	},
	getters: {
		// SERVICE SHOWCASE
		getShowcaseList(state) {
			return state.showcaseList
		},
		getShowcase(state) {
			return state.showcase
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE SHOWCASE
		getShowcaseDeleteStatus(state) {
			return state.showcaseDeleteStatus
		},
		getShowcaseSaveStatus(state) {
			return state.showcaseSaveStatus
		},
		getShowcaseStatus(state) {
			return state.showcaseStatus
		},
	},
	mutations: {
		// SERVICE SHOWCASE
		SHOWCASE_LIST(state, value) {
			state.showcaseList = value
		},
		SET_SHOWCASE(state, value) {
			state.showcase = value
		},

		// STATUS SERVICE SHOWCASE
		SHOWCASE_STATUS(state, value) {
			state.showcaseStatus = value
		},
		SHOWCASE_SAVE_STATUS(state, value) {
			state.showcaseSaveStatus = value
		},
		SHOWCASE_DELETE_STATUS(state, value) {
			state.showcaseDeleteStatus = value
		},
	},
	actions: {
		// Service Showcase
		async fetchShowcaseList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('SHOWCASE_STATUS', 'pending')
			commit('SHOWCASE_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await showcaseList(params)
				commit('SHOWCASE_STATUS', 'init')
				commit('SHOWCASE_LIST', data)
				return data
			} catch (error) {
				commit('SHOWCASE_STATUS', 'init')
				throw error
			}
		},
		async fetchShowcaseByID({ commit }, params) {
			commit('SHOWCASE_STATUS', 'pending')
			try {
				const { data } = await showcaseByID(params)
				commit('SHOWCASE_STATUS', 'init')
				commit('SET_SHOWCASE', data.data)
				return data
			} catch (error) {
				commit('SHOWCASE_STATUS', 'init')

				return error
			}
		},
		async saveNewShowcase({ commit }, params) {
			commit('SHOWCASE_SAVE_STATUS', 'pending')
			try {
				const { data } = await showcaseCreate(params)
				commit('SHOWCASE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SHOWCASE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateShowcase({ commit }, params) {
			commit('SHOWCASE_SAVE_STATUS', 'pending')
			try {
				const { data } = await showcaseUpdate(params)
				commit('SHOWCASE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SHOWCASE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async setShowcaseCurrent({ commit }, id) {
			commit('SHOWCASE_SAVE_STATUS', 'pending')
			try {
				const { data } = await showcaseSetCurrent(id)
				commit('SHOWCASE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SHOWCASE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async toggleMediaPartnerApplications({ commit }, { id, value }) {
			commit('SHOWCASE_SAVE_STATUS', 'pending')
			try {
				const { data } = await showcaseToggleMediaPartnerApplications(id, value)
				commit('SHOWCASE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SHOWCASE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteShowcaseByID({ commit }, params) {
			commit('SHOWCASE_DELETE_STATUS', 'pending')
			try {
				const { data } = await showcaseDestroy(params)
				commit('SHOWCASE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SHOWCASE_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
